/**
 * @class StickyAddToCart
 * @extends {HTMLElement}
 */
class StickyAddToCart extends HTMLElement {
  /** @type {HTMLElement | null} */
  productForm = this.closest('.shopify-section')?.querySelector('.product-form') || null;

  /** @type {HTMLElement | null} */
  addToCart = this.querySelector('[data-add-to-cart]') || null;

  /** @type {HTMLElement | null} */
  soldOut = this.querySelector('[data-sold-out]') || null;

  /** @type {number} */
  productFormBottom = 0;

  /** @type {boolean} */
  hasScrolledPast = false;

  /** @type {number} */
  offsetThreshold = 0;

  connectedCallback() {
    if (!this.productForm) return;

    this.setStickyAtcHeight();
    // Observe the product form, to show/hide the sticky add to cart bar when the product form is out of view.
    this.observeProductForm();

    // Listen for the `variant-change` event
    document.addEventListener('variant-change', (event) => {
      this.render(event);
    });
  }

  observeProductForm() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.hideBar();
          } else {
            this.showBar();
          }
        });
      },
      { threshold: 0 }
    );
    observer.observe(this.productForm);
  }

  setStickyAtcHeight() {
    document.documentElement.style.setProperty(
      '--sticky-atc-height',
      `${this.getBoundingClientRect().height}px`
    );
  }

  showBar() {
    this.setStickyAtcHeight();
    this.classList.add('is-open');
  }

  hideBar() {
    this.classList.remove('is-open');
  }

  render(event) {
    // Update the title
    this.querySelector('[data-sticky-add-to-cart="title"]')
      ? (this.querySelector('[data-sticky-add-to-cart="title"]').textContent =
          event?.detail?.variant?.name)
      : null;

    // Update option selector buttons with the selected variant options
    const variantOptions = event?.detail?.variant?.options || [];
    const triggerButtons = this.querySelectorAll('trigger-option-select');
    triggerButtons.forEach((trigger, index) => {
      const span = trigger.querySelector('span');
      if (span && variantOptions[index]) {
        span.textContent = variantOptions[index];
      }
    });

    // Show the right button state when available
    if (event?.detail?.variant?.available) {
      this.addToCart.classList.remove('hidden');
      this.addToCart.classList.add('inline-flex');
      this.soldOut.classList.remove('inline-flex');
      this.soldOut.classList.add('hidden');
      return;
    }

    // Hide the add to cart button and show the sold out button
    this.addToCart?.classList.remove('inline-flex');
    this.addToCart?.classList.add('hidden');
    this.soldOut?.classList.remove('hidden');
    this.soldOut?.classList.add('inline-flex');
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
